export default __webpack_public_path__ + "static/class_2-d89c8b15ea4679c0fc03b03071546a3f.png";